module.exports = __webpack_public_path__ + "img/knight4cf_feature_01.b8014dae.jpg";